import script from "./Qualification.vue?vue&type=script&setup=true&lang=js"
export * from "./Qualification.vue?vue&type=script&setup=true&lang=js"

import "./Qualification.vue?vue&type=style&index=0&id=33072306&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33072306"]])

export default __exports__